/* ELC Shift — Admin Compliance module (compliance tab: data, render, CSV, AI, period/filter helpers).
   Extracted from admin.html block #12 (Sprint 6) via AST. Behaviour-preserving: every function was a
   global inline declaration, all re-exposed on window. Reads admin globals (DB, staffData, ALL_STORES,
   getAreaStoreMap…) at runtime. Nested helper ymd travels inside its parent. */
(function(){

function initClAdminCompliance() {
  const sel = document.getElementById('clCompStore');
  if (sel && sel.options.length <= 1) {
    ALL_STORES.forEach(s => { const o=document.createElement('option');o.value=s;o.textContent=s;sel.appendChild(o); });
  }
  const fmt = d => d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
  const fromEl = document.getElementById('clCompFrom');
  const toEl   = document.getElementById('clCompTo');
  const d30 = new Date(); d30.setDate(d30.getDate()-30);
  if (fromEl && !fromEl.value) fromEl.value = fmt(d30);
  if (toEl && !toEl.value) toEl.value = fmt(new Date());
  renderAdminCompliance();
}

// Pure: normalise one raw submission into a compliance row. Extracted from
// getAdminComplianceData so the completion-% maths is unit-tested (Rung ②).
// total falls back to the answer count then 1 (never divide by 0); done is the
// stored score, or a count of 'yes' answers when there's no score; pct is the
// rounded completion %.
function complianceRow(r) {
  const answers = r.answers || {};
  const total = r.total || Object.keys(answers).length || 1;
  const done  = r.score !== undefined ? r.score : Object.values(answers).filter(a => a && a.answer === 'yes').length;
  const missed = Object.entries(answers).filter(([,v]) => v && v.answer === 'no').map(([,v]) => v.comment || 'Item marked No');
  const submittedLate = !!(r.submittedLate || (r.items && r.items.submitted_late));
  const lateForDate = r.lateForDate || (r.items && r.items.late_for_date) || null;
  return {
    store: r.store, date: r.date, type: r.type,
    done, total, pct: Math.round(done / total * 100),
    missed, by: r.staffName || r.submittedBy || '—',
    submittedLate, lateForDate
  };
}

// Pure: header summary across compliance rows — average completion, count below
// 90%, and how many were submitted late. Empty → all zeros.
function summariseCompliance(rows) {
  rows = rows || [];
  if (!rows.length) return { count: 0, avg: 0, below: 0, lateCount: 0 };
  const avg = Math.round(rows.reduce((s,r)=>s+r.pct,0)/rows.length);
  const below = rows.filter(r=>r.pct<90).length;
  const lateCount = rows.filter(r=>r.submittedLate).length;
  return { count: rows.length, avg, below, lateCount };
}

function getAdminComplianceData() {
  const from  = document.getElementById('clCompFrom')?.value   || '';
  const to    = document.getElementById('clCompTo')?.value     || '';
  const store = document.getElementById('clCompStore')?.value  || '';
  const type  = document.getElementById('clCompType')?.value   || '';
  // Use adminGetAllSubmissions — it handles key parsing correctly
  let subs = adminGetAllSubmissions();
  if (store) subs = subs.filter(r => r.store === store);
  if (type)  subs = subs.filter(r => r.type  === type);
  if (from)  subs = subs.filter(r => r.date  >= from);
  if (to)    subs = subs.filter(r => r.date  <= to);
  // v56: complianceRow carries through the late-submission flag —
  // adminGetAllSubmissions has it at the top level (localStorage) while
  // DB-sourced rows store it inside items.submitted_late; both are normalised.
  return subs.map(complianceRow);
}

function renderAdminCompliance() {
  const rows = getAdminComplianceData();
  const el = document.getElementById('clComplianceTable');
  if (!el) return;   // v136.8: null-safe (the box may not be on screen)
  if (!rows.length) { el.innerHTML = '<div style="text-align:center;padding:40px;color:var(--sub)">No submissions found for this period</div>'; return; }
  // Summary stats (avg completion, count below 90%, late count) extracted to
  // summariseCompliance() so they're unit-tested (Rung ②).
  const { avg, below, lateCount } = summariseCompliance(rows);
  let html = `<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:14px">
    <div style="background:var(--arota-ok-pale);border-radius:10px;padding:10px;text-align:center"><div style="font-size:20px;font-weight:800;color:var(--arota-green-ink)">${rows.length}</div><div style="font-size:10px;color:var(--sub);text-transform:uppercase;font-weight:600">Submissions</div></div>
    <div style="background:${avg>=90?'var(--arota-ok-pale)':avg>=70?'var(--arota-warn-pale)':'var(--arota-bad-pale)'};border-radius:10px;padding:10px;text-align:center"><div style="font-size:20px;font-weight:800;color:${avg>=90?'var(--arota-green-ink)':avg>=70?'var(--arota-amber-ink)':'var(--arota-red-ink)'}">${avg}%</div><div style="font-size:10px;color:var(--sub);text-transform:uppercase;font-weight:600">Avg Completion</div></div>
    <div style="background:${below===0?'var(--arota-ok-pale)':'var(--arota-bad-pale)'};border-radius:10px;padding:10px;text-align:center"><div style="font-size:20px;font-weight:800;color:${below===0?'var(--arota-green-ink)':'var(--arota-red-ink)'}">${below}</div><div style="font-size:10px;color:var(--sub);text-transform:uppercase;font-weight:600">Below 90%</div></div>
    <div style="background:${lateCount===0?'var(--arota-ok-pale)':'var(--arota-amber-pale)'};border-radius:10px;padding:10px;text-align:center"><div style="font-size:20px;font-weight:800;color:${lateCount===0?'var(--arota-green-ink)':'var(--warn-deep)'}">${lateCount}</div><div style="font-size:10px;color:var(--sub);text-transform:uppercase;font-weight:600">Submitted Late</div></div>
  </div><div class="card" style="padding:0;overflow:hidden"><table class="data-table"><thead><tr><th>Store</th><th>Date</th><th>Type</th><th>Status</th><th>Score</th><th>Missed Items</th><th>Submitted by</th></tr></thead><tbody>`;
  rows.forEach(r => {
    const pc = r.pct>=90?'var(--arota-green-ink)':r.pct>=70?'var(--arota-amber-ink)':'var(--arota-red-ink)';
    const bg = r.pct>=90?'var(--ok-bg)':r.pct>=70?'var(--warn-bg)':'var(--danger-bg)';
    const miss = r.missed.length ? `<span style="color:var(--arota-red-ink);font-size:11px"><span translate="no">${r.missed.slice(0,2).join(', ')}</span>${r.missed.length>2?' +'+( r.missed.length-2)+' more':''}</span>` : '<span style="color:var(--arota-green-ink);font-size:11px">All ✓</span>';
    // v56: status column — "On time" (green) vs "Late" (amber) with the missed date tooltip
    const statusCell = r.submittedLate
      ? `<span style="background:var(--warn-bg);color:var(--warn-deep);padding:2px 8px;border-radius:6px;font-size:11px;font-weight:700" title="Was due ${r.lateForDate || '—'}">⚠ Late</span>`
      : `<span style="background:var(--ok-bg);color:var(--arota-green-ink);padding:2px 8px;border-radius:6px;font-size:11px;font-weight:700">On time</span>`;
    html += `<tr><td><strong translate="no">${escapeHtml((r.store||'').split(' - ').pop())}</strong></td><td style="font-size:12px">${r.date}</td><td>${r.type==='open'?'☀️':r.type==='close'?'🌙':'📋'}</td><td>${statusCell}</td><td><span style="background:${bg};color:${pc};padding:2px 8px;border-radius:6px;font-size:11px;font-weight:700">${r.pct}%</span></td><td>${miss}</td><td style="font-size:11px;color:var(--sub)" translate="no">${escapeHtml(r.by||'')}</td></tr>`;
  });
  el.innerHTML = html + '</tbody></table></div>';
}

function downloadAdminComplianceCSV() {
  const rows = getAdminComplianceData();
  if (!rows.length) { showToast('No data to export','error'); return; }
  // v56: add Status + Due Date columns so late-submission data survives export
  const csv = ['Store,Date,Type,Status,Due Date,Completed,Total,% Complete,Submitted By,Missed Items'];
  rows.forEach(r => csv.push([
    `"${r.store}"`, r.date,
    r.type==='open'?'Opening':r.type==='close'?'Closing':r.type,
    r.submittedLate ? 'Submitted Late' : 'On Time',
    r.lateForDate || '',
    r.done, r.total, r.pct+'%',
    `"${r.by}"`, `"${r.missed.join('; ')}"`
  ].join(',')));
  const blob = new Blob([csv.join('\n')],{type:'text/csv'});
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
  a.download = 'ELC_Checklist_Compliance_'+todayDateStr()+'.csv'; a.click();
  showToast('CSV downloaded','success');
}

function initComplianceTab() {
  // Populate the area-manager filter from the accounts cache. If it's empty
  // (e.g. cold load), DB.accounts.list() warms it; subsequent calls hit cache.
  populateComplianceManagerFilter();
  // Load the scan config in parallel with the summary fetch. We need it to
  // render the settings panel correctly when the user opens it.
  Uploads.compliance.loadComplianceScanConfig();
  Uploads.compliance.loadComplianceSummary();
}

async function populateComplianceManagerFilter() {
  const sel = document.getElementById('complianceFilterManager');
  if (!sel) return;
  try {
    const accounts = await DB.accounts.list();
    const managers = (accounts || [])
      .filter(a => a.role === 'area_manager' && a.active !== false)
      .map(a => a.name)
      .sort();
    // Keep the "All area managers" option, append per-manager.
    sel.innerHTML = '<option value="">All area managers</option>'
      + managers.map(m => '<option value="' + escapeAttr(m) + '">' + escapeHtml(m) + '</option>').join('');
  } catch (e) {
    console.warn('[compliance] could not populate manager filter:', e && e.message);
  }
}

function complianceRangeFor(preset) {
  const now = new Date();
  // Yesterday in Dubai is "now − 4h offset" mapped back. Simpler: just use
  // the local YYYY-MM-DD calc and subtract days.
  function ymd(d) {
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day = String(d.getUTCDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }
  // Shift to Dubai local by adding 4 hours, then take the date part.
  const dubai = new Date(now.getTime() + 4 * 3600 * 1000);
  const yesterday = new Date(dubai);
  yesterday.setUTCDate(yesterday.getUTCDate() - 1);
  if (preset === 'day') {
    const d = ymd(yesterday);
    return { from: d, to: d };
  }
  if (preset === 'week') {
    const start = new Date(yesterday);
    start.setUTCDate(start.getUTCDate() - 6);
    return { from: ymd(start), to: ymd(yesterday) };
  }
  // month
  const start = new Date(yesterday);
  start.setUTCDate(start.getUTCDate() - 29);
  return { from: ymd(start), to: ymd(yesterday) };
}

function setCompliancePeriod(preset) {
  _compliancePeriod = preset;
  // Update tab visual state
  ['day', 'week', 'month'].forEach(p => {
    const btn = document.getElementById('compliancePeriod' + p[0].toUpperCase() + p.slice(1));
    if (!btn) return;
    if (p === preset) { btn.style.background = 'var(--green-on)'; btn.style.color = '#fff'; }   // v136.8: the green white text reads on (5.5:1)
    else              { btn.style.background = 'var(--card)';  btn.style.color = 'var(--text)'; }
  });
  Uploads.compliance.loadComplianceSummary();
}

function categoryLabel(c) {
  return {
    log_compliance:        'logs missing',
    checklist_compliance:  'checklists missing',
    late_clockin:          'late clock-ins',
    break_issue:           'break issues',
    location_off:          'no location fix',   // v129.61: timeouts ≠ staff turning it off
    never_signed_in:       'never signed in',
  }[c] || c;
}

async function copyComplianceEmail() {
  const hint = document.getElementById('complianceCopyHint');
  if (!_complianceData) {
    if (hint) hint.textContent = 'Run a scan first.';
    return;
  }
  const text = Uploads.compliance.formatComplianceEmail(_complianceData);
  try {
    await navigator.clipboard.writeText(text);
    if (hint) {
      hint.textContent = 'Copied — paste into Slack/email.';
      hint.style.color = 'var(--green)';
      setTimeout(() => { hint.textContent = ''; hint.style.color = 'var(--sub)'; }, 4000);
    }
  } catch (e) {
    // Fallback for browsers without async clipboard.
    const ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); if (hint) hint.textContent = 'Copied.'; }
    catch (_) { if (hint) hint.textContent = 'Copy failed — select the text manually.'; }
    document.body.removeChild(ta);
  }
}

function complianceSettingsSelectAll(checked) {
  const panel = document.getElementById('complianceSettingsPanel');
  if (!panel) return;
  panel.querySelectorAll('input[type="checkbox"][data-kind]').forEach(cb => {
    cb.checked = checked;
  });
}

// ── re-expose (preserves the pre-extraction global surface) ──
window.initClAdminCompliance = initClAdminCompliance;
window.getAdminComplianceData = getAdminComplianceData;
window.renderAdminCompliance = renderAdminCompliance;
window.downloadAdminComplianceCSV = downloadAdminComplianceCSV;
window.initComplianceTab = initComplianceTab;
window.populateComplianceManagerFilter = populateComplianceManagerFilter;
window.complianceRangeFor = complianceRangeFor;
window.setCompliancePeriod = setCompliancePeriod;
window.categoryLabel = categoryLabel;
window.copyComplianceEmail = copyComplianceEmail;
window.complianceSettingsSelectAll = complianceSettingsSelectAll;

})();
